import './profile.css';
import { useState, useEffect } from "react";
import { useAuthValue } from './AuthContext';
import { signOut } from 'firebase/auth';
import { auth } from "./firebase";
import { ref, get, getDatabase, child} from "firebase/database";
import { useNavigate } from "react-router-dom";


function Profile() {
  const navigate = useNavigate();
  const { currentUser } = useAuthValue();
  const uid = currentUser?.uid;
  const db = ref(getDatabase());
  const [userData, setUserData] = useState(null); // Usa un estado para guardar los datos y actualizar la vista cuando se reciban

  useEffect(() => {
    get(child(db, `users/${uid}`)).then((snapshot) => {
      const datos = snapshot.val();
      const userData = {
        name: datos.name,
        email: datos.email,
        phone: datos.phone,
        activeMode: datos.activeMode,
        expertMode: datos.expertMode,
        userNew: datos.userNew,
        userStatus: datos.userStatus,
        userRequestId: datos.userRequestId
      };
      setUserData(userData); // Actualiza el estado con los datos obtenidos
    });
  }, [db, uid]); // Usa useEffect() para ejecutar get() cuando cambien db o uid

  if (!userData) {
    return <p>Cargando datos...</p>; // Muestra un mensaje de carga mientras se obtienen los datos
  }

  return (
    <div className="center">
      <div className="profile">
        <div>
          <img src="logo.png" alt="Logo" width={300} />
        </div>
        <div>
          <h1 style={{ fontSize: 26, color: "#03a99f", fontWeight: "bold" }}>
            Perfil
          </h1>
        </div>
        <div>
          <p><strong>Nombre: </strong>{userData.name}</p>
          <p><strong>Telefono: </strong>{userData.phone}</p>
          <p><strong>Email: </strong>{userData.email}</p>
          <p><strong>Modo Profesional: </strong>{userData.expertMode}</p>
          <p>
            <strong>Email verified: </strong>
            {`${currentUser.emailVerified}`}
          </p>
        </div>

        <button onClick={() => navigate("/ModePro")} style={{ backgroundColor: "#001439" }}>
          <span style={{ color: "white", fontSize: 16 }}>Activa modo Profesional</span>
        </button>
        <br></br>
        <button style={{ backgroundColor: "#001439" }}>
          <span style={{ color: "white", fontSize: 16 }} onClick={() => signOut(auth)}>Cerrar Sesion</span>
        </button>
      </div>
    </div>
  )
}

export default Profile;
